// The athlete's avatar (Figma "Avatar"): their photo, else their initials.
// In the sidebar it opens You.
import * as React from 'react';
import { cn } from '../../lib/utils';

export function initials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}

export function Avatar({ name, src, size = 40, className }) {
  const style = { width: size, height: size, fontSize: size > 48 ? Math.round(size * 0.33) : undefined };
  return (
    <span role="img" aria-label={name || 'You'} style={style}
      className={cn('inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-border-default bg-bg-raised type-button-small text-text-primary', className)}>
      {src ? <img src={src} alt="" className="h-full w-full object-cover" /> : <span aria-hidden="true">{initials(name)}</span>}
    </span>
  );
}
